import { SpaceBetween } from '@cloudscape-design/components';
import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group';
import { useEffect, useRef, useState } from 'react';
import { useGlobalState } from '../../../../context/GlobalStateContext';
import { CustomAppLayout } from '../../../layout';
const _preserve = React.version;
////import { useStoreAdmin } from '../../../context/useStoreAdmin';
//import { useStoreAdmin } from '../../../context/useStoreAdmin';
import { addNotification, addNotificationStatus, buildBreadcrumbItems, getCookie, getUrlVersion, setData, setLoading } from '../../../../commons/functions';


import dayjs from "dayjs";
import isBetween from "dayjs/plugin/isBetween";
import React from 'react';
import BookingGenerate, { BookingGenerateHandles } from '../../../../../components/generates/BookingGenerate';
import { ItemBooking, ItemsMovement } from '../../../../../resources/types';
dayjs.extend(isBetween);


const pageSize = 20;
interface HourOption {
    value: string;
    label: string;
}
export const MembersMercenariesBookPage = () => {
    const { menu, idUser } = useGlobalState();
    const [idMovement, setIdMovement] = useState<number>(0);
    const [movement, setMovement] = useState<ItemsMovement>();


    useEffect(() => {
        const handleHashChange = () => {
            const hash = window.location.hash;
            const params = new URLSearchParams(hash.split("?")[1]);
            const idMovement = params.get("m");
            if (idMovement) {
                setIdMovement(Number(idMovement));
            }
        };
        window.addEventListener("hashchange", handleHashChange);
        handleHashChange();
        return () => window.removeEventListener("hashchange", handleHashChange);
    }, []);
    useEffect(() => {
        if (idMovement > 0) {
            handleGetMovement()
        }
    }, [idMovement]);


    const handleGetMovement = async () => {
        setLoading(true);
        try {
            const response = await fetch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/admin/movements/movement',
                    'JWT': getCookie("JWT"),

                },
                body: JSON.stringify({
                    idMovement: idMovement,
                    idAccountPlan: 83024,
                    columns: "idMovement, jsonMovement, voucherStage, receipt, (ISNULL((select idBooking from tbl_Bookings where idMovement=v_movements.idMovement and isDeleteBooking=0),0)) as idBooking"
                })
            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }

            const dataWeb = await response.json();
            addNotificationStatus(dataWeb, setData);
            if (dataWeb.code === 0) {
                console.log(dataWeb.movement)
                if (dataWeb.movement === null) {
                    addNotification("PAX no encontrado en movimientos contables.", "error", setData);
                }
                else if (dataWeb?.movement?.idBooking !== 0) {
                    setMovement(undefined)
                    addNotification("No se puede reservar este vuelo, ya tiene la reserva #" + dataWeb?.movement?.idBooking + " asignada.", "error", setData);
                }
                else if (dataWeb?.movement?.voucherStage === 2) {
                    setMovement(dataWeb.movement)
                    console.log(dataWeb.movement)
                }
                else if (dataWeb?.movement?.voucherStage === 3) {
                    setMovement(undefined)
                    addNotification("No se puede reservar este vuelo, ya ha sido realizado.", "error", setData);
                }
            }

        } catch (error) {
            console.error('Error fetching users:', error);
        } finally {
            setLoading(false);
        }
    }
    const handleBook = async (booking: ItemBooking) => {
        setLoading(true);
        if (booking && booking?.dateStart && booking.dateStart !== ""
            && booking?.dateEnd && booking.dateEnd !== ""
            && booking?.timeStart && booking.timeStart !== ""
            && booking?.timeEnd && booking.timeEnd !== ""
            && booking?.idEquipment > 0 && booking.idUserPilot > 0
        ) {
            try {
                const response = await fetch(`${getUrlVersion()}/routing/v1/`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'x-routing': '/private/user/bookings/add',
                        'JWT': getCookie("JWT"),

                    },
                    body: JSON.stringify({
                        ...(movement?.idMovement && { idMovement: movement.idMovement }),
                        commit: true,
                        startDate: booking.dateStart + " " + booking.timeStart + ":00",
                        endDate: booking.dateEnd + " " + booking.timeEnd + ":00",
                        idEquipment: booking.idEquipment,
                        idUserPilot: booking.idUserPilot,
                        idUserInstructor: booking.idUserInstructor,
                        idBookingType: booking.idBookingType,
                        idUser: booking.idUserPilot,
                        idInstructor: booking.idUserInstructor,
                        obsBooking: booking.obsBooking,
                        obs: booking.obsBooking,
                        towType: booking.towType,
                        pax: booking.pax,
                    })
                });

                if (!response.ok) {
                    throw new Error(`HTTP error: ${response.status}`);
                }

                const dataWeb = await response.json();
                addNotificationStatus(dataWeb, setData);
                if (dataWeb.code === 0) {
                    clearBooking()
                    window.location.hash = '#members/mercenaries/default'
                }

            } catch (error) {
                console.error('Error fetching users:', error);
            } finally {
                setLoading(false);
            }
        }

    };

    const bookingRef = useRef<BookingGenerateHandles>(null);
    const clearBooking = () => {
        //console.log("bookingRef.current", bookingRef.current)
        if (bookingRef.current) {
            bookingRef.current.clearBooking();
        }
    };
    return (
        <CustomAppLayout
            toolsHide={true}


            contentType="form"
            breadcrumbs={
                <BreadcrumbGroup
                    items={buildBreadcrumbItems(menu)}
                    expandAriaLabel="Show path"
                    ariaLabel="Breadcrumbs"
                />
            }
            content={
                <SpaceBetween size="xs">
                    {!!movement && movement.idMovement > 0 && (
                        <BookingGenerate
                            ref={bookingRef}
                            idUser={idUser}
                            movement={movement}
                            idGroupTypes={[1044, 1043]}
                            idBookingTypes={[4720]}
                            onChange={(booking) => {
                                //console.log(booking)
                                handleBook(booking)
                            }}
                        />
                    )}



                </SpaceBetween >
            }
        />

    );
};